import React, { useRef } from 'react';
import { SITE_CONFIG } from '../config';
import { useLanguage } from '../contexts/LanguageContext';

const reviews = [
  {
    author: 'Lorena Padron',
    detail: { en: 'Bought in Lawrenceville · 2020', es: 'Compró en Lawrenceville · 2020' },
    body: {
      en: 'Lorena praised Giovanni’s professionalism and the clear guidance he provided throughout her home purchase.',
      es: 'Lorena destacó el profesionalismo de Giovanni y la orientación clara que recibió durante toda la compra de su vivienda.'
    }
  },
  {
    author: 'zuser20161005035855633',
    detail: { en: 'First-time buyer in Suwanee · 2020', es: 'Primera compra en Suwanee · 2020' },
    body: {
      en: 'This first-time buyer said Giovanni made the experience feel smooth and far easier than expected.',
      es: 'Este comprador primerizo señaló que Giovanni hizo que la experiencia fuera sencilla y mucho más fácil de lo esperado.'
    }
  },
  {
    author: 'marlopezzz1985',
    detail: { en: 'Bought in Alpharetta · 2019', es: 'Compró en Alpharetta · 2019' },
    body: {
      en: 'After finding a home they loved in Alpharetta, this client highlighted the professionalism of Giovanni and his team.',
      es: 'Después de encontrar una casa que les encantó en Alpharetta, este cliente resaltó el profesionalismo de Giovanni y su equipo.'
    }
  },
  {
    author: 'colelexiii',
    detail: { en: 'Bought and sold in Atlanta · 2019', es: 'Compró y vendió en Atlanta · 2019' },
    body: {
      en: 'This client valued Giovanni’s start-to-finish guidance, responsiveness, and knowledge during both sides of a move.',
      es: 'Este cliente valoró la orientación de principio a fin, la rapidez de respuesta y el conocimiento de Giovanni al comprar y vender.'
    }
  },
  {
    author: 'jeremythompson367',
    detail: { en: 'Bought in Lawrenceville · 2016', es: 'Compró en Lawrenceville · 2016' },
    body: {
      en: 'Jeremy emphasized Giovanni’s reliability, responsiveness, and strong knowledge of the local real estate market.',
      es: 'Jeremy destacó la confiabilidad, la rapidez de respuesta y el sólido conocimiento de Giovanni sobre el mercado inmobiliario local.'
    }
  },
  {
    author: 'Tasha Threatt',
    detail: { en: 'First-time buyer in Lawrenceville · 2014', es: 'Primera compra en Lawrenceville · 2014' },
    body: {
      en: 'Tasha appreciated Giovanni’s help as a first-time buyer, including guidance with down-payment and closing-cost negotiations.',
      es: 'Tasha agradeció la ayuda de Giovanni como compradora primeriza, incluyendo orientación para negociar el pago inicial y los costos de cierre.'
    }
  }
];

export default function ZillowReviewWidget() {
  const { language } = useLanguage();
  const reviewRailRef = useRef(null);
  const es = language === 'es';
  const copy = es ? {
    kicker: 'Reseñas verificadas en Zillow',
    title: 'Experiencias reales, contadas por sus clientes.',
    rating: 'calificación general',
    count: '10 reseñas',
    selected: 'Reseñas seleccionadas de 5 estrellas',
    previous: 'Ver reseñas anteriores',
    next: 'Ver más reseñas',
    source: 'Resúmenes parafraseados de reseñas publicadas en Zillow.',
    viewAll: 'Ver todas en Zillow',
    ratingAria: '4.6 de 5 estrellas',
    fiveStarAria: '5 de 5 estrellas'
  } : {
    kicker: 'Verified Zillow reviews',
    title: 'Real experiences, shared by his clients.',
    rating: 'overall rating',
    count: '10 reviews',
    selected: 'Selected 5-star reviews',
    previous: 'View previous reviews',
    next: 'View more reviews',
    source: 'Paraphrased highlights from reviews published on Zillow.',
    viewAll: 'View all on Zillow',
    ratingAria: '4.6 out of 5 stars',
    fiveStarAria: '5 out of 5 stars'
  };

  const scrollReviews = (direction) => {
    const rail = reviewRailRef.current;
    if (!rail) return;
    rail.scrollBy({ left: direction * Math.max(280, rail.clientWidth * 0.78), behavior: 'smooth' });
  };

  return (
    <section className="gt-zillow gt-section" aria-labelledby="gt-zillow-title">
      <header className="gt-section-head">
        <span className="gt-kicker gt-kicker--dark">{copy.kicker}</span>
        <h2 id="gt-zillow-title">{copy.title}</h2>
      </header>
      <div className="gt-zillow-widget">
        <aside className="gt-zillow-summary">
          <span className="gt-zillow-brand">Zillow</span>
          <strong>4.6</strong>
          <div className="gt-zillow-stars" aria-label={copy.ratingAria}>★★★★★</div>
          <p>{copy.rating}<br />{copy.count}</p>
          <a href={SITE_CONFIG.AGENT.ZILLOW_REVIEW} target="_blank" rel="noreferrer">{copy.viewAll} <span>↗</span></a>
        </aside>
        <div className="gt-zillow-reviews">
          <div className="gt-zillow-controls">
            <span>{copy.selected}</span>
            <div>
              <button type="button" onClick={() => scrollReviews(-1)} aria-label={copy.previous}>←</button>
              <button type="button" onClick={() => scrollReviews(1)} aria-label={copy.next}>→</button>
            </div>
          </div>
          <div className="gt-zillow-rail" ref={reviewRailRef} tabIndex="0">
            {reviews.map((review) => (
              <article key={review.author}>
                <div className="gt-zillow-card-stars" aria-label={copy.fiveStarAria}>★★★★★</div>
                <p>{review.body[language]}</p>
                <footer><strong>{review.author}</strong><span>{review.detail[language]}</span></footer>
              </article>
            ))}
          </div>
          <small>{copy.source}</small>
        </div>
      </div>
    </section>
  );
}
